
import { Tooltip} from "@material-tailwind/react";
import { useRef } from "react";

const DisplayTrackNW = ({ currentTrack }) => {
  const frames = [ { color: "red" },
  { transform: "scale(1.05)", color: "red" },
  { transform: "translateY(-10%)", color: "red" }, 
  { transform: "translateY(-30%)" , color: "red"}, 
  { transform: "scale(1.2)" , color: "red"},
  { transform: "translateY(-10%)" , color: "red"},
  { transform: "translateY(0%)" , color: "red"}, 
  { transform: "scale(1.2)", color: "red" },
  { transform: "scale(1.0)" , color: "inherit"},
  ]
  const inputRef_0 = useRef(null);

  let audio_0 = new Audio(currentTrack.audio);
  const Playit_0 = () => {
    setTimeout(() => {
      inputRef_0.current.animate(  
        frames,{ duration: audio_0.duration*1000 , fill: "forwards", iterations: 1 } 
      );
      audio_0.play();
      }, 2)
    
  };

  const correctSound = currentTrack.answer === 1 ? currentTrack.sound2 : currentTrack.sound1;

  
  
  return (
    <div className="flex w-full items-center gap-2 rounded-xl border border-slate-200 bg-white p-2">
      
      <Tooltip className="flex flex-col bg-indigo-300 font-medium text-white rounded-full px-3"
            animate={{
              mount: { scale: 1.1, y: 0 },
              unmount: { scale: 0, y: 25 },}} 
             content={currentTrack.translation}
             > 
         
       
         <button className="basis-2/5 rounded-lg bg-transparent px-3 py-2 font-serif text-sm font-semibold text-slate-700 transition hover:bg-cyan-50 hover:text-cyan-900" onClick={Playit_0}>
          <p ref={inputRef_0}>{currentTrack.word}</p>

        </button>
        
      </Tooltip>
      
      <button aria-label="Play word" className="basis-1/5 rounded-lg bg-cyan-50 py-3 text-sm font-bold text-cyan-800 transition hover:bg-cyan-100" onClick={Playit_0}>
        <p>&#9654;</p>
      </button>
      <div className="basis-2/5 rounded-lg px-3 py-2 text-center font-serif text-sm font-semibold text-slate-700">
        {correctSound}
      </div>
      
    </div>
  );
};
export default DisplayTrackNW;
